import React, { useState } from "react";
import TimePeriodPicker from "./TimePeriodPicker";
export default function TimePeriodLabel(props) {
  let [showPicker, togglePicker] = useState(false);

  let from = props.from?.split(":") || [];
  let to = props.to?.split(":") || [];

  return (
    <React.Fragment>
      {showPicker && (
        <TimePeriodPicker
          from={props.from}
          to={props.to}
          title={props.title}
          onClose={() => togglePicker(false)}
          onChange={(period) => {
            togglePicker(false);
            props.onChange(period);
          }}
        />
      )}
      <div
        onClick={() => togglePicker(!props.readOnly)}
        className={`time-period-label ${!props.readOnly && "open"} ${
          props.className ? props.className : ""
        }`}
      >
        <div className="d-flex align-items-center">
          <div>
            {from[0]}:{from[1]}
          </div>
          <div className="px-1">-</div>
          <div>
            {to[0]}:{to[1]}
          </div>
        </div>
        <div>
          {!props.readOnly && (
            <i
              title="Удалить строку"
              onClick={(e) => {
                e.stopPropagation();
                props.onRemove();
              }}
              className="fa fa-times cursor-pointer text-hover-danger ml-2"
            ></i>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
